Number.prototype.format = function (n, x) {
  var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\." : "$") + ")";
  return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, "g"), "$&,");
};

const clearUpsellProducts = () => {
  while(upsellProducts.length > 0) {
    upsellProducts.pop();
  }
};

const upsellProducts = [];

const openUpsellPopup = () => {
  upsellModal.open();
  
  checkMainOptions(0);
  checkMainOptions(1);
  checkMainOptions(2);
};

const setVariantInfo = (e) => {
  let product = null;
  if (isNaN(e)) {
    product = e.target.closest(".product");
  } else {
    product = document.querySelector(`.product[data-index="${e}"]`);
  }
  const productIndex = isNaN(e) ? +product.getAttribute("data-index") : e;
  const variant = chooseVariant(productIndex);
  if (variant !== null) {
    
    if (variant.featured_image !== null) {
      const image = product.querySelector("img");
      image.src = variant.featured_image.src.replace(/(.jpg|.png)/, "_150x$1");
    }
    
    if (isNaN(e) && e.target.id.indexOf("option-0") > 0) {
      checkSecondaryOptions(productIndex);
    } else {

      const oldPrice = (variant.compare_at_price || variant.price);
      const price = variant.price;
      const discount = (oldPrice - price) / 100;

      if (oldPrice !== price) {
        product.querySelector("span.strike").innerText = "$" + (oldPrice / 100);
        product.querySelector("span.price").innerText = "$" + (price / 100).toFixed(2);
        product.querySelector("span.discount").innerText = "($" + discount.format(2) + " off)";
      } else {
        product.querySelector("span.strike").innerText = "";
        product.querySelector("span.price").innerText = "$" + (price / 100);
        product.querySelector("span.discount").innerText = "";
      }
    }
  }
};

const chooseVariant = (productIndex) => {
  const product = document.querySelector(`.product[data-index="${productIndex}"]`);
  if (product !== null) {
    const productVariants = variants[productIndex];
    let selectedVariant = null;
    const options = [...product.querySelectorAll("select")];
    if (options.length) {
      const option1 = options[0].value || null;
      const option2 = options[1]?.value || null;
      productVariants.forEach(variant => {
        if (variant.option1 === option1 && variant.option2 === option2) {
          selectedVariant = variant;
        }
      });
    } else {
      selectedVariant = productVariants[0];
    }

    return selectedVariant;
  }
    
  return null;
}

const addToOrder = (productIndex) => {
  const product = document.querySelector(`.product[data-index="${productIndex}"]`);
  const productUpsellQty = [...document.querySelectorAll("#PopupUpsell .js-qty__num")][productIndex].value;
  
  const button = product.querySelector(".btn");
  button.classList.toggle("added");
  
  if (button.classList.contains("added")) {
    button.innerHTML = "Added to Order (" + productUpsellQty + ")<span class='remove-order'>Click to decline</span>";

    product.querySelectorAll("select").forEach(item => {
      item.setAttribute("disabled", "disabled");
    });
    
    product.querySelector(".js-qty").style.display = "none";

    const variant = chooseVariant(productIndex);
    product.querySelector("input[name=variant]").value = variant.id;

  } else {

    button.innerHTML = "Add to Order";

    product.querySelectorAll("select").forEach(item => {
      item.removeAttribute("disabled");
    });
    
    product.querySelector(".js-qty").style.display = "block";
  
    product.querySelector("input[name=variant]").value = "";
  }
};

const addProductsToCart = (addProducts) => {
  if (addProducts === true) {
	const productsUpsell = [...document.querySelectorAll("input[name=variant]")].filter(input => input.value !== "");
	const productsUpsellQty = [...document.querySelectorAll("#PopupUpsell .js-qty__num")];
    productsUpsell.forEach((input, index) => {
      upsellProducts.push({ id: +input.value, qty: +productsUpsellQty[index].value });
    });
  
    localStorage.setItem("fcw-discount-code", "BUNDLE15");
  }
  
  if (upsellProducts.length) {
    const data = {
      items: []
    };

    upsellProducts.forEach((product) => {
      data.items.push({
        id: product.id,
        quantity: product.qty
      });
    });

    data.items.reverse();

    theme.cart.addItemFromForm(data).then(function (product) {
    
      [...document.querySelectorAll(".added")].forEach(button => {
        button.innerHTML = "Add to Order";
        button.classList.remove("added");
      });

      [...document.querySelectorAll("select")].forEach(select => {
        select.removeAttribute("disabled");
      });

      [...document.querySelectorAll(".js-qty")].forEach(qtyInput => {
        qtyInput.style.display = "block";
      });

      [...document.querySelectorAll("input[name=variant]")].forEach(input => {
        input.value = "";
      });
      
      upsellModal.close();
      
      $("body").trigger("added.ajaxProduct");
      
      setTimeout(() => {
        document.querySelector("#CartContainer .discountCode").value = "BUNDLE15";
      }, 1000);
      
      clearUpsellProducts();
    });
  }
};

const addUpsellProductsToCart = (e) => {
  e.preventDefault();
  
  if (popupUpsell) {
    const form = e.target.closest("form");
    qty = +form.querySelector("input[name=quantity]").value;
    
    let productId = productVariant;
    
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("variant")) {
      productId = urlParams.get("variant");
    }
    
    upsellProducts.push({ id: productId, qty: qty });
    
    openUpsellPopup();
    
    return false;
  }
  
  return true;
};

const checkSecondaryOptions = (productIndex) => {
  const elementId = productIndex + 1;
  const mainSelectedOption = document.querySelector(`#SingleOptionSelector-product-${elementId}-option-0 option:checked`);
  const secondaryOptions = [...document.querySelectorAll(`#SingleOptionSelector-product-${elementId}-option-1 option`)];
  
  if (mainSelectedOption && secondaryOptions.length) {
    secondaryOptions.forEach(secondaryOption => {
      secondaryOption.removeAttribute("disabled", "disabled");
    });

    if (lockedVariants[productIndex].hasOwnProperty(mainSelectedOption.value)) {
      secondaryOptions.forEach(secondaryOption => {
        if (lockedVariants[productIndex][mainSelectedOption.value].includes(secondaryOption.value)) {
          secondaryOption.setAttribute("disabled", "disabled");
          secondaryOption.removeAttribute("selected");
        }
      });
    }
    
    const secondarySelectedOption = document.querySelector(`#SingleOptionSelector-product-${elementId}-option-1 option:checked`);
    if (secondarySelectedOption.disabled) {
      for (let i = 0; i < secondaryOptions.length; i++) {
        if (!secondaryOptions[i].disabled) {
          document.querySelector(`#SingleOptionSelector-product-${elementId}-option-1`).value = secondaryOptions[i].value;
          break;
        }
      }
    }
  }
  
  setVariantInfo(productIndex);
};

const checkMainOptions = (productIndex) => {
  const elementId = productIndex + 1;
  const mainOptions = [...document.querySelectorAll(`#SingleOptionSelector-product-${elementId}-option-0 option`)];
  const secondaryOptions = [...document.querySelectorAll(`#SingleOptionSelector-product-${elementId}-option-1 option`)];
  
  mainOptions.forEach(mainOption => {
    if (lockedVariants[productIndex].hasOwnProperty(mainOption.value)) {
      if (lockedVariants[productIndex][mainOption.value].length === secondaryOptions.length) {
        mainOption.setAttribute("disabled", "disabled");
        mainOption.removeAttribute("selected");
      }
    }
  });
  
  checkSecondaryOptions(productIndex);
};

if (popupUpsell) {
  document
  	.querySelector("button.add-to-cart")
  	.addEventListener("click", addUpsellProductsToCart, false);
  
  document.querySelectorAll("#PopupUpsell select").forEach(item => {
  	item.addEventListener("change", setVariantInfo, false);
  });
  
  console.log(variants);
  
  var lockedVariants = {};
  blockedVariants.forEach((variants, index) => {
    lockedVariants[index] = {};
    variants.forEach(variant => {
      const types = variant.split(" / ");
      if (types.length === 2) {
        if (!lockedVariants[index].hasOwnProperty (types[0])) {
          lockedVariants[index][types[0]] = [];
        }
        lockedVariants[index][types[0]].push(types[1]);
      } else {
        if (!lockedVariants[index].hasOwnProperty (types[0])) {
          lockedVariants[index][types[0]] = [];
        }
      }
    });
  });
}
